<template>
  <span>
    <button
      class="btn btn-sm btn-outline-primary"
      :disabled="disabled || isUploading"
      @click="triggerFile"
    >
      <i class="bi bi-upload" />
      {{ isUploading ? "Uploading…" : "Upload CSV" }}
    </button>
    <input
      ref="fileInput"
      accept=".csv"
      class="d-none"
      type="file"
      @change="onFileSelected"
    />
    <div
      ref="reportModal"
      class="modal fade"
      data-bs-backdrop="static"
      data-bs-keyboard="true"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload Report</h5>
            <button
              class="btn-close"
              data-bs-dismiss="modal"
              type="button"
            />
          </div>
          <div class="modal-body">
            <p>
              Created: <strong>{{ report?.createdCount || 0 }}</strong> · Updated:
              <strong>{{ report?.updatedCount || 0 }}</strong> · Failed: <strong>{{ report?.failedCount || 0 }}</strong>
            </p>
            <div
              v-if="report?.errors?.length"
              class="alert alert-warning"
            >
              <strong>Row errors:</strong>
              <ul class="mb-0">
                <li
                  v-for="(err, idx) in report.errors"
                  :key="idx"
                >Line {{ err.lineNumber }}: {{ err.message }}</li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              type="button"
            >Close</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  props: {
    /** The vuex action path to dispatch, e.g. 'rateCards/uploadCsv'. */
    uploadAction: { type: String, required: true },
    /** Extra arguments passed to the upload action alongside the FormData. */
    actionPayload: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    suppressErrorToast: { type: Boolean, default: false },
  },
  emits: [ 'uploaded', 'failed', 'upload-start' ],
  data() {
    return {
      isUploading: false,
      report: null,
      reportModalRef: null,
    };
  },
  mounted() {
    this.reportModalRef = new Modal(this.$refs['reportModal']);
  },
  methods: {
    triggerFile() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    async onFileSelected(e) {
      const file = e.target.files?.[0];
      if (!file) return;
      this.isUploading = true;
      this.$emit('upload-start');
      try {
        const formData = new FormData();
        formData.append('file', file);
        const result = await this.$store.dispatch(this.uploadAction, { formData, ...this.actionPayload });
        this.report = result || null;
        this.$emit('uploaded', this.report);
        if (Array.isArray(this.report?.rows)) {
          return;
        }
        if (this.report && Array.isArray(this.report.errors)) {
          const ok = (this.report?.failedCount || 0) === 0;
          if (ok) {
            this.$toast.success(`Created ${this.report?.createdCount || 0}, updated ${this.report?.updatedCount || 0}.`);
          } else {
            this.reportModalRef.show();
          }
        }
      } catch (err) {
        this.$emit('failed', err);
        if (!this.suppressErrorToast) {
          this.$toast.error(err?.message || 'Upload failed.');
        }
      } finally {
        this.isUploading = false;
      }
    },
  },
};
</script>
